import Lottie from "react-lottie-player";
import animationData from "./animationData.json";

const LoadingAnimation = () => (
  <Lottie
    play
    loop
    animationData={animationData}
    style={{ height: "300px", width: "300px", margin: "0 auto" }}
  />
);

export default LoadingAnimation;
